/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_menu': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: '<path pid="0" d="M40.333 10.99a1.824 1.824 0 00-1.824-1.823H23.824a1.824 1.824 0 100 3.648H38.51a1.824 1.824 0 001.824-1.824zM40.333 22a1.824 1.824 0 00-1.824-1.824H5.491a1.824 1.824 0 000 3.648h33.018A1.824 1.824 0 0040.333 22zM38.51 31.185a1.824 1.824 0 010 3.648H16.49a1.824 1.824 0 010-3.648h22.02z" _fill="#0E0F16"/>'
  }
})
